
            // Analytics only in production
            if (import.meta.env.PROD) {
                const s = document.createElement('script')
                s.src = 'https://backoffice-usage.baltic-watches.com/api/script.js'
                s.dataset.siteId = '03b1ebb15ca0'
                s.defer = true
                document.head.appendChild(s)
            }
        